<!--
 * @Author: guoyu
 * @Date: 2020-07-24 18:58:30
 * @LastEditors: your name
 * @LastEditTime: 2021-04-12 17:00:55
 * @Description: 简单的下拉选择
-->
<template>
  <el-select v-model="value" placeholder="请选择" v-bind="$attrs">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item[labelKey]"
      :value="item[valKey]"
    >
      <slot :item="item" :active="item[valKey] == value"></slot>
    </el-option>
  </el-select>
</template>
<script>
export default {
  model: {
    prop: 'val',
    event: 'change'
  },
  props: {
    val: { type: [String, Number], default: '' },
    options: { type: Array, default: () => [] },
    labelKey: { type: String, default: 'label' },
    valKey: { type: String, default: 'value' }
  },
  computed: {
    value: {
      get() {
        return this.val;
      },
      set(newVal) {
        this.$emit('change', newVal);
      }
    }
  }
};
</script>
<style scoped></style>
